'use client'

import { useDocumentInfo } from '@payloadcms/ui'

import { ReceptionistPanelClient } from './ReceptionistPanelClient.jsx'

// Mounted as a UI field at the top of the Clients edit form (see
// src/collections/Clients.ts `receptionistPanel`) — same in-flow admin-card
// slot as PrdPanel on Projects. On the create view (no id yet) the wizard
// has nothing to drive; the admin fills the fields and saves first.
export function ReceptionistPanel() {
  const { id } = useDocumentInfo()
  if (!id) return null
  return <ReceptionistPanelClient clientId={id} />
}
